import { render, staticRenderFns } from "./ProposeEvaluator.vue?vue&type=template&id=28f8c3cf&"
import script from "./ProposeEvaluator.vue?vue&type=script&lang=js&"
export * from "./ProposeEvaluator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports